const LinkedIn = () => (
  <svg
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      opacity="0.25"
      x="1.47732"
      y="0.562521"
      width="28.125"
      height="28.1261"
      rx="14.0625"
      stroke="white"
      strokeWidth="1.12504"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9151 19.4998H10.6648V12.749H12.9151V19.4998Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7831 11.2499H11.7703C11.0989 11.2499 10.6648 10.7497 10.6648 10.1246C10.6648 9.48621 11.1121 9 11.7962 9C12.4804 9 12.9017 9.48621 12.9147 10.1246C12.9147 10.7497 12.4804 11.2499 11.7831 11.2499Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1654 19.4996H18.9542V15.9709C18.9542 15.0846 18.6343 14.4798 17.8338 14.4798C17.2228 14.4798 16.859 14.8875 16.6991 15.2813C16.6407 15.4224 16.6263 15.6191 16.6263 15.8162V19.4998H14.4148C14.4148 19.4998 14.4439 13.523 14.4148 12.9041H16.6263V13.8383C16.9198 13.3892 17.4455 12.749 18.6195 12.749C20.0746 12.749 21.1655 13.6919 21.1655 15.7178L21.1654 19.4996Z"
      fill="white"
    />
  </svg>
)

export default LinkedIn
